import {comm} from './comm'

const $IndexClass= comm;
$IndexClass.init(container);
$IndexClass.run();